<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-end">
        <v-flex xs12>
          <h3 class="text-center" v-if="client">View Client Information</h3>
          <v-btn small @click="goTo('/user/client/edit')" class="primary pull-right hidden" title="Edit" v-if="client && client.id">
            <v-icon left>mdi-lead-pencil</v-icon>Edit
          </v-btn>
          <v-btn small @click="addClient = !addClient" class="primary pull-right" title="Add Client Information" v-else>
            <v-icon left>mdi-lead-pencil</v-icon>Add Client Profile
          </v-btn>
        </v-flex>
        <v-flex xs12 sm10 md8 v-if="client && client.id">
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>
              <span class="text-center">{{ client.name }}</span>
            </v-card-title>
            <v-card-text>
              <p>Date of Birth <b v-html="client.date_of_birth"></b></p>
              <p>Gender <b v-html="client.gender"></b></p>
              <p>Phone <b v-html="client.phone"></b></p>
              <p>Email <b v-html="client.email"></b> <a :href="'mailto:' + client.email">Send Mail</a></p>
              <p>Residence <b v-html="client.location"></b></p>
              <p>Allergies <b v-html="client.allergies"></b></p>
              <p>Next of Kin</p>
              <p class="ml-5">Name <b v-html="client.next_of_kin_name"></b></p>
              <p class="ml-5">Phone <b v-html="client.next_of_kin_phone"></b></p>
            </v-card-text>
            <v-card-actions class="hidden">
              <v-spacer></v-spacer>
              <v-btn small color="orange" @click="goTo('/clients/' + client.id + '/edit')">Edit</v-btn>
              <!-- <confirms-password @confirmed="deleteClient(client)">
                <v-btn small color="red">Delete</v-btn>
              </confirms-password> -->
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs11 sm10 md8 v-else>
          <transition name="slide-fade">
            <register-client v-if="addClient"></register-client>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/User'
  import RegisterClient from '@/Pages/Auth/Client'

  export default {
    name: 'ClientView',
    layout,
    props: [
      'user', 'client', 'create'
    ],
    components: {
      RegisterClient,
    },
    metaInfo () {
      return {
        title: 'View Client Profile',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        addClient: this.create
      }
    }
  }
</script>

<style>
   /**/
</style>
